import { Button, Col, Modal, Row, Space } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { LeftSiderBarWith } from "../../../constants/constants";
import "./footer-action.scss";

interface Props {
    onRefer: Function;
    onApprove: Function;
}

const FooterAction = (props: Props) => {

    const { t } = useTranslation();

    const confirmApprove = () => {
        Modal.confirm({
            content: t("Global.lbApproveConfirmMessage"),
            onOk: () => { props.onApprove() },
            icon: '',
            width: 304,
            okText: "Ok",
            cancelText: t("Global.lbCancel")
        });
    }


    const confirmRefer = () => {
        Modal.confirm({
            content: t("Global.lbReturnConfirmMessage"),
            onOk: () => { props.onRefer() },
            icon: '',
            width: 304,
            okText: "Ok",
            cancelText: t("Global.lbCancel")
        });
    }


    return (
        <div className="footer-action" style={{ left: LeftSiderBarWith }}>
            <Row>
                <Col span={14} offset={5} className="footer-action-content">
                    <span>
                        {t("Global.appovalQuestion")}
                    </span>

                    <Space>
                        <Button shape="round" className="btn-danger" onClick={confirmRefer}>
                            {t("Global.lbReturn")}
                        </Button>
                        <Button shape="round" className="btn-success" onClick={confirmApprove}>
                            {t("Global.lbApprove")}
                        </Button>
                    </Space>

                </Col>
            </Row>
        </div>
    )
}


export default FooterAction;